import { ModelBase } from "./ModelBase";


export class EmbedConfig extends ModelBase {
    Id: string;
    EmbedUrl: string;
    EmbedToken: EmbedToken;
    IsEffectiveIdentityRolesRequired: boolean;
    IsEffectiveIdentityRequired: boolean;
    EnableRLS: boolean;
    Username: string;
    Roles: string;
}
export class EmbedToken {
    token: string
    tokenId: string
    expiration: Date
}